module.exports = __webpack_public_path__ + "static/media/bride-2.25cfb227.jpg";